<template>
    <el-dialog
            class="detail-dialog-container"
            :visible.sync="detailDialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="1200px"
            center>
        <div class="dialog-container flex flex-direction ">
            <div class="dialog-header flex align-center justify-between flex-shrink">
                <div class="flex align-center">
                    <el-image class="header-logo" :src="orginizInfo.morglogo" v-if="orginizInfo.morglogo"></el-image>
                    <img src="../../../assets/img/avatar_member.jpg" alt="" class="logo" v-else/>
                    <div class="header-name">{{orginizInfo.morgname}}</div>
                </div>
                <i class="dialog-close el-icon-close" @click="cancel"></i>
            </div>

            <div class="dialog-content flex flex-direction">
                <div class="title">{{detail.title}}</div>
                <div class="content flex flex-direction">
                    <div v-html="detail.content"></div>
                    <div class="flex flex-direction margin-top-sm justify-start self-start"
                         v-if="detail && detail.file_json.length > 0">
                        <h3>附件</h3>
                        <div v-for="(file,index) in detail.file_json" :key="index"
                             class="flex align-center margin-top-xs">
                            <el-link :href="file.url" class="margin-right" target="_blank"
                                     type="primary">{{ file.name }}
                            </el-link>
                            <el-button  @click="downloadFile(file.url,file.name)" type="text">下载</el-button>

                        </div>
                    </div>
                    <div class="time self-end">{{orginizInfo.morgname}}</div>
                    <div class="time self-end">{{detail.add_time}}</div>
                </div>
            </div>
            <div class="dialog-operate flex align-center justify-center">
                <el-button class="operate" :class="{disabled:detail.is_feedback}" v-if="detail.is_need_feedback" @click="applyDialogVisible = true">
                    <i class="el-icon-chat-dot-square"></i>{{detail.is_feedback ? '已反馈' : '反馈'}}
                </el-button>
                <el-button class="operate black" @click="cancel">关闭</el-button>
            </div>
            <div class="dialog-footer flex align-center justify-around flex-shrink">
                <div class="content">{{orginizInfo.morgname}}</div>
                <div class="content">电话：{{orginizInfo.morgtel}}</div>
                <div class="content">邮箱：{{orginizInfo.morgemail}}</div>
            </div>
        </div>
        <notice-feedback-dialog :nid="nid" :applyDialogVisible="applyDialogVisible"
                                @feedbackState="feedbackState"></notice-feedback-dialog>
    </el-dialog>
</template>

<script>
    import {getNoticeDetail,getOrganizInfo} from '@/api/branch'
    import {zhDate} from '@/utils/utils'
    import NoticeFeedbackDialog from "./NoticeFeedbackDialog.vue";
    import {downloadFile} from "@/api/login";

    export default {
        components: {NoticeFeedbackDialog},
        name: "noticeDetailDialog",
        props: {
            detailDialogVisible: {
                type: Boolean,
                default: false
            },
            nid: { //详情ID
                type: Number,
            },
        },
        data() {
            return {
                orginizInfo: '',
                detail: '',
                applyDialogVisible: false
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            }
        },
        created() {
            this.getOrganizInfo()
            if (this.nid)this.init()
        },
        methods: {
            async getOrganizInfo() {
                let _data = await getOrganizInfo()
                if (_data.status === 200) {
                    this.orginizInfo = _data.data
                }

            },
            async init() {
                let _data = await  getNoticeDetail(this.nid)
                if (_data.status === 200) {
                    _data.data.file_json = _data.data.file_json ? JSON.parse(_data.data.file_json) : []
                    _data.data.user_feedback = _data.data.user_feedback ? JSON.parse(_data.data.user_feedback) : []
                    _data.data.add_time = zhDate(_data.data.add_time * 1000)
                    this.detail = _data.data
                }
            },
            cancel() {
                this.$emit('watchState', false)
            },
            feedbackState(state) {
                this.applyDialogVisible = false;
                if (state) {
                    this.$emit('watchState', true)
                    this.init()
                }
            },
            async downloadFile(fileUrl,fileName) {
                if (!fileUrl) {
                    return;
                }
                let _data = await  downloadFile(fileUrl)
                let url = window.URL.createObjectURL(new Blob([_data.data]));
                let link = document.createElement('a');
                link.style.display = 'none';
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            }
        },
        watch: {
            detailDialogVisible() {

            },
            nid() {
                if (this.nid && this.detailDialogVisible) {
                    this.detail = ''
                    this.init()
                }
            }
        }
    }
</script>

<style scoped lang="scss">

    .detail-dialog-container {
        .dialog-container {
            height: 800px;
            .dialog-header {
                height: 55px;
                padding: 0 20px;
                border-bottom: 1px solid #eeeeee;
                .header-logo {
                    width: 30px;
                    height: 30px;
                    border-radius: 30px;
                }
                .header-name {
                    font-size: 16px;
                    color: #0a2240;
                    margin-left: 6px;
                }
                .dialog-close {
                    font-size: 21px;
                    color: #0a2240;
                    font-weight: bold;
                    cursor: pointer;
                }
            }
            .dialog-content {
                padding: 40px 80px;
                height: 605px;
                .title {
                    font-size: 24px;
                    font-weight: bold;
                    color: #0a2240;
                    text-align: center;
                }
                .content {
                    margin-top: 38px;
                    overflow-y: scroll;
                    &::-webkit-scrollbar {
                        display: none
                    }

                }
                .time {
                    font-size: 16px;
                    color: #0a2240;
                    margin-top: 16px;
                }
            }
            .dialog-operate {
                height: 100px;
                .operate {
                    width: 200px;
                    height: 40px;
                    border-radius: 20px;
                    font-size: 16px;
                    background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                    linear-gradient(#ff9600, #ff9600);
                    background-blend-mode: normal, normal;
                    color: #ffffff;
                    &.black {
                        background: #0a2240 none;
                    }
                    &.disabled {
                        background: #b4c7e5 none;
                    }
                }
                .operate + .operate {
                    margin-left: 80px;
                }
            }
            .dialog-footer {
                height: 40px;
                background-color: #e7eff9;
                padding: 0 20px;
                border-radius: 0 0 10px 10px;
                .content {
                    font-size: 16px;
                    color: #8b9fbe;
                }
            }
        }
    }
</style>